import { Companies } from '../constants';

export const getCompanyIdByJobNumber = (jobNumber: string): number => {
  if (!jobNumber || jobNumber.length < 6) {
    return -1;
  }

  let firstPart = jobNumber[0];
  let secondPart = jobNumber[1];
  let thirdPart = jobNumber[2];

  if (
    ['0', '1', '2'].includes(firstPart) &&
    ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(secondPart) &&
    thirdPart == '7'
  ) {
    return Companies.MotorCityElectricService;
  } /*else if (firstPart === '1' || thirdPart === '1') {
      return Companies.MotorCityElectric;
    } */ else if (firstPart === '3') {
    return Companies.StelkoElectric;
  } else if (firstPart === '4') {
    return Companies.HuronValleyElectric;
  } else if (firstPart === '5') {
    return Companies.MotorCityElectricUtilities;
  } else if (firstPart === '6') {
    return Companies.WilliamsElectricalAndTelecommunications;
  } else if (firstPart === '7') {
    return Companies.RotorElectric;
  } else if (firstPart === '8') {
    return Companies.MidSouthContractors;
  } else if (firstPart === '9') {
    return Companies.MotorCityElectricTechnologies;
  } else if (firstPart === '1' && secondPart === '4') {
    return Companies.MidMichiganElectricalSolutions;
  }

  return Companies.MotorCityElectric;
  // return -1;
};
